import { publishedRates } from "@/data/resort";
import { Eyebrow, MaskReveal, Reveal } from "../reveal";

export function OccupancyPolicy() {
  return (
    <section
      id="occupancy"
      aria-labelledby="occupancy-heading"
      className="bg-secondary/45 py-16 md:py-20"
    >
      <div className="shell">
        <Reveal>
          <Eyebrow>Who&apos;s Traveling with You?</Eyebrow>
        </Reveal>
        <h2 id="occupancy-heading" className="display-lg mt-6 max-w-[16ch]">
          <MaskReveal>Occupancy Guidelines</MaskReveal>
        </h2>

        <Reveal delay={0.1}>
          <div className="mt-10 grid gap-6 md:grid-cols-[1fr_auto_1fr_auto_1fr] md:items-center">
            <div className="border border-border bg-background px-6 py-8 text-center md:px-8">
              <p className="eyebrow text-muted-foreground">Included</p>
              <p className="font-display mt-4 text-3xl tracking-tight text-primary md:text-4xl">
                Up to {publishedRates.occupancyIncluded} Guests
              </p>
            </div>
            <p
              className="text-center font-display text-3xl text-muted-foreground"
              aria-hidden="true"
            >
              +
            </p>
            <div className="border border-border bg-background px-6 py-8 text-center md:px-8">
              <p className="eyebrow text-muted-foreground">Additional Guests</p>
              <p className="font-display mt-4 text-3xl tracking-tight text-primary md:text-4xl">
                {publishedRates.additionalGuestFee} / Person / Day
              </p>
            </div>
            <p
              className="text-center font-display text-3xl text-muted-foreground"
              aria-hidden="true"
            >
              =
            </p>
            <div className="border border-primary bg-primary px-6 py-8 text-center text-primary-foreground md:px-8">
              <p className="eyebrow text-primary-foreground/70">Maximum</p>
              <p className="font-display mt-4 text-3xl tracking-tight md:text-4xl">
                {publishedRates.maxOccupancy} Guests Per Site
              </p>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.16}>
          <p className="mt-10 max-w-3xl text-base leading-relaxed text-muted-foreground">
            Published site rates include up to four people. Additional guests may be added for $5
            per person, per day, up to a maximum total occupancy of six people per lot.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
